/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvoiceDto } from './InvoiceDto';
import {
    InvoiceDtoFromJSON,
    InvoiceDtoFromJSONTyped,
    InvoiceDtoToJSON,
} from './InvoiceDto';

/**
 * 
 * @export
 * @interface InvoicesDto
 */
export interface InvoicesDto {
    /**
     * The invoices.
     * @type {Array<InvoiceDto>}
     * @memberof InvoicesDto
     */
    items: Array<InvoiceDto>;
    /**
     * The poral link.
     * @type {string}
     * @memberof InvoicesDto
     */
    portalLink: string | null;
}

/**
 * Check if a given object implements the InvoicesDto interface.
 */
export function instanceOfInvoicesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "portalLink" in value;

    return isInstance;
}

export function InvoicesDtoFromJSON(json: any): InvoicesDto {
    return InvoicesDtoFromJSONTyped(json, false);
}

export function InvoicesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(InvoiceDtoFromJSON)),
        'portalLink': json['portalLink'],
    };
}

export function InvoicesDtoToJSON(value?: InvoicesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(InvoiceDtoToJSON)),
        'portalLink': value.portalLink,
    };
}

